export const SDK_VERSION = '7.80.0';
